import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Data } from '@angular/router';
import { AuthService } from '@core/auth.service';
import { IonicModule } from '@ionic/angular';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';
import { catchError, concatMap, of, Subject, switchMap, takeUntil, timer, Observable } from 'rxjs';
import { AnimationService } from 'src/app/services/animation.service';

@Component({
  selector: 'app-syndicate-goldring',
  templateUrl: './syndicate-goldring.component.html',
  styleUrl: './syndicate-goldring.component.scss',
  standalone: true,
  imports: [IonicModule, LottieComponent]
})
export class SyndicateGoldringComponent implements OnInit, OnDestroy {

  private animationDestroy$ = new Subject<void>();
  updateAnimationSubject = new Subject<{ location_id: string, delayTime: number }>();
  public userId: string;
  goldStatus: boolean;
  goldDuration: number;
  goldoptions: AnimationOptions = { path: '' };

  @Input() goldRingWidgetDetails?;
  @Input() goldRingToolTipMsg?;
  @Input() showGoldRingToolTip?;
  @Output() picktingsOpenEvent = new EventEmitter<void>();
  @Output() showGoldExpandViewOpenEvent = new EventEmitter<void>();
  @Output() grToolTipEvent = new EventEmitter<void>();

  constructor(
    private animationService: AnimationService,
    private authService: AuthService,
  ) { }

  async ngOnInit() {
    await this.authService
      ?.getUid("SyndicateGoldringComponent")
      ?.then((uid) => {
        this.userId = uid;
      })
      .catch((error) => {
        return error;
      });
    this.getAnimation();
    this.initUpdateAnimation();
  }

  getAnimation() {
    const category = "syndicate";
    this.animationService.getAnimationBasedOnCategory(this.userId, category).pipe(
      takeUntil(this.animationDestroy$)
    ).subscribe((res: Data) => {
      if (!res) return;
      res?.forEach(item => {
        if (!item) return;
        switch (item?.location_id) {
          case 'gold_rings_widget':
            this.goldStatus = item?.status;
            this.goldDuration = item?.duration;
            this.goldoptions = {
              path: `../../../assets/${item?.lottie_animation_URL}`,
            }
            break;
        }
      });
    })
  }

  initUpdateAnimation() {
    this.updateAnimationSubject
      .pipe(
        concatMap(({ location_id, delayTime }) =>
          timer(delayTime * 1000).pipe(
            switchMap(() => this.sendUpdateStatusFB(location_id) || of(null))
          )
        ),
        takeUntil(this.animationDestroy$)
      ).subscribe();
  }

  // Dismiss the animation when user clicks on it.
  updateAnimationStatus(location_id: string, delayTime: number) {
    if (location_id && delayTime > 0 && delayTime != null) {
      this.updateAnimationSubject.next({ location_id, delayTime });
    }
  }

  onClick(location_id: string) {
    this.sendUpdateStatusFB(location_id).subscribe();
  }

  sendUpdateStatusFB(location_id: string): Observable<Data> {
    // Ensure location_id is available, return empty Observable if not
    if (!location_id) {
      return of(null);
    }

    // Check if gold ring animation is active
    if (this.goldStatus) {
      return this.authService.getV2CloudFunction("updatemicroanimationv2", {
        "userId": this.userId,
        "locationIds": location_id,
        "status": false
      }).pipe(
        catchError((error) => {
          console.error('Error in sendUpdateStatusFB cloud function:', error);
          return of(null);
        })
      );
    }

    // Return empty Observable instead of undefined
    return of(null);
  }

  picktings_open() {
    this.picktingsOpenEvent.emit();
  }

  showGoldExpandView() {
    this.showGoldExpandViewOpenEvent.emit();
  }
  grToolTip() {
    this.grToolTipEvent.emit();
  }

  ngOnDestroy() {
    if (this.animationDestroy$) {
      this.animationDestroy$.next();
      this.animationDestroy$.complete();
    }
  }
}
